<template>
  <div class="content">
    <!-- 咨询弹窗 -->
    <el-dialog
      v-model="consultationDialogVisible"
      title="咨询服务"
      width="500px"
      :before-close="handleConsultationClose"
      class="consultation-dialog"
    >
      <div class="dialog-form-content">
        <el-form ref="consultationForm" :model="consultationForm" label-position="top" :rules="consultationRules">
          <el-form-item label="企业名称" prop="companyName">
            <el-input v-model="consultationForm.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="consultationForm.contactPerson" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="consultationForm.contactPhone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
          <el-form-item label="咨询内容" prop="consultationContent">
            <el-input
              v-model="consultationForm.consultationContent"
              type="textarea"
              :rows="4"
              :maxlength="500"
              show-word-limit
              placeholder="请简要描述您的咨询需求"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-btn-dialog" @click="submitConsultation">
              提交
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-left: 8px;">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/kjcgzh/kjcgzh.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
<!--          <p class="banner-subtitle">TECHNOLOGY TRANSFORMATION</p>-->
          <h1 class="banner-title">科技成果转化</h1>
        </div>
      </div>
    </div>

    <!-- 科技成果转化区域 -->
    <div class="transform-section">
      <!-- 服务选项卡 -->
      <div class="services-section">
        <div class="services-tabs">
          <button 
            v-for="(item, index) in tablists" 
            :key="index"
            :class="['service-tab', { 'active': tabis === item }]"
            @click="tabchange(item)"
          >
            <span class="tab-text">{{ item }}</span>
          </button>
        </div>
      </div>

      <!-- 内容卡片 -->
      <div class="content-card">
        <div class="card-left">
          <div class="card-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect x="12" y="8" width="24" height="32" rx="2" stroke="#3B82F6" stroke-width="2"/>
              <path d="M18 16H30M18 22H26M18 28H30" stroke="#3B82F6" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="card-title">{{ tabis }}</h2>
        </div>
        
        <div class="card-right">
          <div class="card-content">
            {{ content }}
          </div>
          <div class="card-footer">
            <el-button type="primary" class="consult-btn" @click="openConsultationDialog">
              立即咨询
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>

import { postAction, getAction } from '@/api/requests'
import Cookies from 'js-cookie'

  export default {
    name: 'kjcgzhContent',
    components: {
  
     
    },
    data(){
      return{
        listnum:0,
        tableData:[],
        tablists:['技术合同登记','产学研合作','大型设备仪器共享','概念验证中心','中试基地','新型研发基地'],
        tabis:'技术合同登记',
        content:'技术合同登记指技术合同登记机构对技术合同当事人申请认定登记的合同文本从形式上、技术上进行核查，确认其是否符合技术合同要求的专项管理工作。技术合同认定登记情况直观反映我国科技成果转移转化效率和技术要素市场活跃程度，是我国技术市场工作的重要组成部分。平台开展国有企业技术合同登记。用户在第三方完成技术开发、转让、咨询或者服务交易后签订合同，可在技术合同登记系统进行合同登记；在河南科交平台挂牌成交的技术交易合同，凭出具的技术交易凭证可在技术合同认定登记时实行免审或快速审核。',
        consultationDialogVisible: false,
        consultationForm: {
          companyName: '',
          contactPerson: '',
          contactPhone: '',
          consultationContent: ''
        },
        consultationRules: {
          companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
          contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          contactPhone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          consultationContent: [{ required: true, message: '请输入咨询内容', trigger: 'blur' }]
        }
      }
    },
    mounted(){
      this.injectDialogStyles()
      this.prefillUserInfo()
    },
    methods:{
      prefillUserInfo() {
        const token = Cookies.get('Admin-Token')
        if (!token) return
        getAction('/getInfo').then(res => {
          if (res.code === 200) {
            const u = res.user || {}
            this.consultationForm.companyName = u.enterpriseName || (u.dept && u.dept.deptName) || ''
            this.consultationForm.contactPerson = u.nickName || u.userName || ''
            this.consultationForm.contactPhone = u.phonenumber || ''
          }
        }).catch(() => {})
      },
      injectDialogStyles() {
        const style = document.createElement('style')
        style.textContent = `
          .consultation-dialog .el-dialog__header {
            background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
            padding: 24px 32px !important; border-radius: 16px 16px 0 0 !important; margin: 0 !important;
          }
          .consultation-dialog .el-dialog__title { font-size: 20px !important; font-weight: 600 !important; color: #FFFFFF !important; }
          .consultation-dialog .el-dialog__headerbtn {
            background: rgba(255,255,255,0.2) !important; position: absolute; top: 24px; right: 32px; width: 36px; height: 36px; border-radius: 50%;
          }
          .consultation-dialog .el-dialog__close { color: #FFFFFF !important; }
        `
        document.head.appendChild(style)
      },
      openConsultationDialog() {
        this.consultationDialogVisible = true
      },
      handleConsultationClose() {
        this.consultationDialogVisible = false
        this.$refs.consultationForm.resetFields()
      },
      submitConsultation() {
        this.$refs.consultationForm.validate((valid) => {
          if (valid) {
            postAction('/trade/project_consult/submit', {
              consultContent: this.consultationForm.consultationContent,
              consultDeptName: this.consultationForm.companyName,
              consultType: 'achievement',
              contactName: this.consultationForm.contactPerson,
              contactPhone: this.consultationForm.contactPhone
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('咨询申请已提交，我们会尽快与您联系！')
                this.handleConsultationClose()
              } else {
                this.$message.error(res.msg || '提交失败')
              }
            }).catch(() => {
              this.$message.error('提交失败，请稍后重试')
            })
          } else {
            return false
          }
        })
      },
      tabchange(item){
        this.tabis = item
        if(item=='技术合同登记'){
          this.content ='技术合同登记指技术合同登记机构对技术合同当事人申请认定登记的合同文本从形式上、技术上进行核查，确认其是否符合技术合同要求的专项管理工作。技术合同认定登记情况直观反映我国科技成果转移转化效率和技术要素市场活跃程度，是我国技术市场工作的重要组成部分。平台开展国有企业技术合同登记。用户在第三方完成技术开发、转让、咨询或者服务交易后签订合同，可在技术合同登记系统进行合同登记；在河南科交平台挂牌成交的技术交易合同，凭出具的技术交易凭证可在技术合同认定登记时实行免审或快速审核。'
        } else if(item=='产学研合作'){
          this.content = '科技成果从完成技术原理研究到转化为现实生产力一般都要经历实验室小试、中试放大以及批量生产等多个环节。中试基地涵盖科技成果筛选与前景评估、集成开发与工程熟化、批量试制与测试验证、技术示范推广等功能。通过中试环节能够及时发现、解决在大规模量产前面临的一系列问题，从而进一步完善产品方案和产品工艺，提高科技成果转化效率。'
        }else if(item=='大型设备仪器共享'){
          this.content = '新型研发机构是聚焦科技创新需求，主要从事科学研究、技术创新和研发服务，投资主体多元化、管理制度现代化、运行机制市场化、用人机制灵活的独立法人机构。主要开展基础研究、应用基础研究，产业共性关键技术研发、科技成果转移转化，以及研发服务等。'
        }else if(item=='概念验证中心'){
          this.content = '概念验证是运用市场化思维逻辑和手段对专利转化落地可行性、商业性等进行调研、评估，以规划确定专利转化的技术路线和商业模式、路径。概念验证中心服务指为创新主体建立的概念验证提供服务，为企业种子资金、商业顾问等提供个性化服务。'
        }else if(item=='中试基地'){
          this.content = '科技成果从完成技术原理研究到转化为现实生产力一般都要经历实验室小试、中试放大以及批量生产等多个环节。中试基地涵盖科技成果筛选与前景评估、集成开发与工程熟化、批量试制与测试验证、技术示范推广等功能。通过中试环节能够及时发现、解决在大规模量产前面临的一系列问题，从而进一步完善产品方案和产品工艺，提高科技成果转化效率。'
        }else if(item=='新型研发基地'){
          this.content = '新型研发机构是聚焦科技创新需求，主要从事科学研究、技术创新和研发服务，投资主体多元化、管理制度现代化、运行机制市场化、用人机制灵活的独立法人机构。主要开展基础研究、应用基础研究，产业共性关键技术研发、科技成果转移转化，以及研发服务等。'
        }
      }
    }
  }
  </script>
  
  <style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  position: relative;
  padding-bottom: 20px;
}



/* 科技成果转化区域 */
.transform-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background: #F5F7FA;
}

/* 服务选项卡区域 */
.services-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
}

.services-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 48px;
  background: #F3F4F6;
  border-radius: 50px;
  padding: 10px;
}

.service-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: transparent;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 15px;
  color: #9CA3AF;
  font-weight: 500;
  position: relative;
}

.service-tab:hover {
  color: #6B7280;
}

.service-tab.active {
  background: #155DFC;
  color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.tab-icon {
  font-size: 18px;
  font-weight: 400;
}

.service-tab.active .tab-icon {
  font-weight: 600;
}

.tab-text {
  font-size: 15px;
}

/* 内容卡片 */
.content-card {
  width: 1200px;
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  display: flex;
  gap: 80px;
  align-items: flex-start;
}

.card-left {
  flex-shrink: 0;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px 30px;

}

.card-icon {
  width: 80px;
  height: 80px;
  background: #EFF6FF;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  text-align: center;
  position: relative;
  padding-bottom: 28px;
}

.card-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: #3B82F6;
  border-radius: 2px;
}

.card-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;


}

.card-content {
  font-size: 15px;
  line-height: 2;
  color: #6B7280;
  text-align: justify;
  text-indent: 2em;
}

.card-footer {
  display: flex;
  justify-content: flex-start;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
}

.more-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #3B82F6;
  text-decoration: none;
  transition: all 0.3s;
}

.more-link:hover {
  color: #2563EB;
  gap: 10px;
}

.more-link svg {
  transition: transform 0.3s;
}

.more-link:hover svg {
  transform: translateX(4px);
}

/* 咨询按钮样式 */
.card-footer {
  margin-top: 20px;
  text-align: right;
}

.consult-btn {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  border: none;
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s;
}

.consult-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

/* 弹窗提交按钮样式 */
.submit-btn-dialog {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  margin-top: 8px;
}

.submit-btn-dialog:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}
  </style>
  
  